export default function downloadCSV(CSVData: string, filename: string): void {
  const link = document.createElement('a');
  link.download = filename;
  link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(CSVData)}`;
  link.target = '_blank';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
